import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths } from '@utils/constants';
import { axios } from '@utils/lib';

export const getUserIdDetailsAsync = createAsyncThunk(
  'api/getUserIdDetailsAsync',
  async (query: IGetUserIdDetail, { rejectWithValue, dispatch }) => {
    const { appId, dbId, userId } = query;
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IUserIdDetailRes>(
        Enums.HTTP_METHOD.GET,
        Paths.USER_ID_DETAIL.replace(':appId', appId)
          .replace(':dbId', dbId)
          .replace(':id', userId),
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const updateUserIdAsync = createAsyncThunk(
  'api/updateUserIdAsync',
  async (data: IUserIdUpdate, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { appId, dbId, userId, userIdForm } = data;
    try {
      const { data } = await axios.request<IUserIdDetailRes>(
        Enums.HTTP_METHOD.PUT,
        Paths.USER_ID_DETAIL.replace(':appId', appId)
          .replace(':dbId', dbId)
          .replace(':id', userId),
        userIdForm,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
